import { setColorCallback } from "../App";
import { setStringCallback } from "../App";
import { setIntCallback } from "../App";
import { setInt2Callback } from "../App";

import { MessageTypes } from "./Enums";

export let webSocket;
export let clientID;

export const PayloadTypes = {
    String: "String",
    Int: "Int",
    Float: "Float",
    Bool: "Bool",
    Vector2: "Vector2",
    Vector3: "Vector3",
    JSON: "JSON",
};

export const setupClient = (serverAddress) => {
    webSocket = new WebSocket(serverAddress);

    webSocket.onopen = onOpen;
    webSocket.onclose = onClose;
    webSocket.onmessage = onMessage;
};

const onOpen = (e) => {
    console.log("Connection opened");

    clientID = localStorage.getItem("clientID");

    sendJSONMessage({
        id: "client_connect",
        payloadType: "clientID",
        payload: clientID,
        date: localStorage.getItem("serverDate")
    });
};

const onClose = (e) => {
    console.log("Connection closed");
};

const onMessage = (e) => {
    const jsonData = JSON.parse(e.data);

    switch (jsonData.id) {
        case "client_no_server":
            //console.log("No server, need to retry");
            break;
        case "client_connect":
            //console.log(`New user connect: ${jsonData.payload}`);
            localStorage.setItem("clientID", jsonData.payload);
            localStorage.setItem("serverDate", jsonData.date);
            break;
        case "client_json":
            const data = JSON.parse(jsonData.payload);

            if (data.code === "int") {
                setIntCallback(data.val);
            } else if (data.code === "color") {
                setColorCallback(data.color);
            } else if (data.code === "string") {
                setStringCallback(data.str);
            }
            else if (data.code === "int2") {
                setInt2Callback(data.val);
            }

            break;
        default:
            break;
    }
};

export const sendJSONMessage = (data) => {
    if (webSocket.readyState === 1)
        webSocket.send(JSON.stringify(data));
};

export const sendClientMessage = (data) => {
    data.clientID = localStorage.getItem("clientID");

    let json = JSON.stringify(data);
    // console.log(json);

    if (webSocket.readyState === 1)
        webSocket.send(json);
};

export const sendAimAngle = (values) => {
    if (webSocket.readyState === 1)
        webSocket.send(GetArrayBuffer(values, MessageTypes.AimAngle));
}

export const sendAimAngleAndShoot = (values) => {
    if (webSocket.readyState === 1)
        webSocket.send(GetArrayBuffer(values, MessageTypes.AimAngleAndShoot));
}

const GetArrayBuffer = (values, messageType) => {
    if (!Array.isArray(values))
        values = [values];

    let buffer = new ArrayBuffer(8 + values.length * 4);

    let intSlot = new Int32Array(buffer, 0, 2);
    intSlot.set([messageType, parseInt(localStorage.getItem("clientID"))]);

    let floatSlot = new Float32Array(buffer, 8, values.length);
    for (let i = 0; i < values.length; i++)
        floatSlot[i] = values[i];

    return new Uint8Array(buffer).buffer;
}

